import { gsap } from "gsap"
import { SplitText } from "gsap/SplitText"

// Project page
export const infoStagger = (el: any) => {
  return gsap.from(el, {
    scrollTrigger: { trigger: ".c-project-details", start: "0px 70%" },
    y: "100%",
    opacity: 0,
    duration: 0.6,
    ease: "expo.out",
    stagger: 0.125,
  })
}

export const descStagger = (el: any) => {
  return gsap.from(el, {
    scrollTrigger: { trigger: ".c-project-desc__inner", start: "0px 75%" },
    y: "100%",
    opacity: 0,
    duration: 0.6,
    ease: "expo.out",
    stagger: 0.125,
    delay: 0.6,
  })
}

export const quoteAnim = (quote: any, name: any, company: any) => {
  if (document.fonts) {
    document.fonts.ready.then(() => {
      const splitQuote = new SplitText(quote, {
        type: "lines",
      })

      const splitName = new SplitText(name, {
        type: "lines",
      })
      new SplitText(name, {
        type: "lines",
        linesClass: "u-overflow-reveal",
      })

      return gsap
        .timeline({
          scrollTrigger: {
            trigger: quote,
            start: "0px 75%",
          },
        })
        .from(splitQuote.lines, {
          y: "100%",
          opacity: 0,
          duration: 0.6,
          ease: "expo.out",
          stagger: 0.1,
        })
        .from(
          splitName.lines,
          {
            y: "200%",
            skewY: "10%",
            duration: 0.6,
            ease: "expo.out",
            stagger: 0.2,
          },
          "-=0.6"
        )
        .from(
          company,
          {
            opacity: 0,
            duration: 0.3,
            ease: "linear",
          },
          "-=0.45"
        )
    })
  } else {
    setTimeout(() => {
      const splitQuote = new SplitText(quote, {
        type: "lines",
      })

      const splitName = new SplitText(name, {
        type: "lines",
      })
      new SplitText(name, {
        type: "lines",
        linesClass: "u-overflow-reveal",
      })

      return gsap
        .timeline({
          scrollTrigger: {
            trigger: quote,
            start: "0px 75%",
          },
        })
        .from(splitQuote.lines, {
          y: "100%",
          opacity: 0,
          duration: 0.6,
          ease: "expo.out",
          stagger: 0.1,
        })
        .from(
          splitName.lines,
          {
            y: "200%",
            skewY: "10%",
            duration: 0.6,
            ease: "expo.out",
            stagger: 0.2,
          },
          "-=0.6"
        )
        .from(
          company,
          {
            opacity: 0,
            duration: 0.3,
            ease: "linear",
          },
          "-=0.45"
        )
    }, 200)
  }
}
